// Constants for CreateTicket module

// Slot types enum - defines the types of slots that can be booked
export const SLOT_TYPES = {
    CUSTOMER_COMPLAINT: 'CUSTOMER_COMPLAINT',
    MEDICAL_ESCALATION: 'MEDICAL_ESCALATION'
};

// Export any other constants that might be needed in the future